/* oxlint-disable react-hooks-js/immutability */
/* eslint-disable react-hooks/immutability */

import { ChangeEvent, useState } from 'react';

import { useTranslation } from '@mint-lib/i18n';
import { useSnapshot } from 'valtio';

import { Input } from '../../atoms/Input.jsx';
import type { TemplateDuplicationFormState } from './types.js';

export const TemplateNameInput = ({
  state,
}: {
  state: TemplateDuplicationFormState;
}) => {
  const { t } = useTranslation('@myn/import-hub');

  const snap = useSnapshot(state);

  const isDuplicateNameError =
    snap.ui.submissionError === 'DuplicatedTemplateNameError';

  const [inputValue, setInputValue] = useState('');

  return (
    <Input
      label={t('Template name*')}
      placeholder={state.form.name}
      value={inputValue}
      onChange={(e: ChangeEvent<HTMLInputElement>) => {
        setInputValue(e.target.value);
        state.form.name = e.target.value;
        if (isDuplicateNameError) {
          state.ui.submissionError = null;
        }
      }}
      infoIconWithTooltip={t('Must be unique and not empty.')}
      maxLength={64}
      size="medium"
      autoComplete="off"
      color={isDuplicateNameError ? 'error' : 'default'}
      helperText={isDuplicateNameError ? t('Template name must be unique') : ''}
    />
  );
};
